<div class="mobile-nav-menu d-flex position-fixed flex-column  bg-primary container">
  <!-- NAV BAR -->
  <div class="mobile-nav-bar d-flex justify-content-between  bg-primary">
    <div class="d-flex col-4 align-items-center">
      <fgb-notification-button></fgb-notification-button>
    </div>

    <button
      attr.aria-label="{{ 'nav.toggle.screenreader' | translate }}"
      class="nav-item fw-bold navbar-toggler m-0 px-2"
      (click)="isCollapsed = !isCollapsed"
    >
      <span class="icon material-icons material-mobile-nav">menu</span>
    </button>
  </div>

  <!-- NAV SCREEN -->
  <div [ngbCollapse]="isCollapsed" class="mobile-nav-menu-dropdown bg-primary">
    <div class="d-flex flex-column mobile-nav-menu-content">
      <!-- Close Button -->
      <button
        class="close-button position-absolute border-0"
        attr.aria-label="{{ 'modal.close' | translate }}"
        (click)="isCollapsed = !isCollapsed"
      >
        <i class="material-icons close-btn">close</i>
      </button>
      <!-- Logo -->
      <div class="mobile-bar">
        <img alt="" class="logo px-2" [src]="'logo/club-bear-logo.svg' | contentAssetImage" draggable="false" />
      </div>

      <!-- Nav Buttons -->
      <div class="container mobile-nav-button-container">
        <ul *notInProductCode="productcode.NonRenewing" class="navbar-nav me-auto w-100" #greedyNav>
          <li class="nav-item" routerLink="/account">
            <span class="icon material-icons material-dropdown-icon" aria-hidden="true">account_circle</span>
            <a class="nav-text text-white">{{ 'nav.account' | translate }}</a>
          </li>
          <li class="nav-item" routerLink="/rewards/wallet">
            <span class="icon material-icons material-symbols-outlined">account_balance_wallet</span>
            <a class="nav-text text-white">{{ 'nav.wallet' | translate }}</a>
          </li>
          <li class="nav-item" routerLink="/earn">
            <span class="icon material-icons material-symbols-outlined">loyalty</span>
            <a class="nav-text text-white">{{ 'nav.mobile.earn' | translate }}</a>
          </li>

          <li class="nav-item" routerLink="/badges">
            <span class="icon material-icons material-symbols-outlined">emoji_events</span>
            <a class="nav-text text-white">{{ 'nav.challenges' | translate }}</a>
          </li>

          <li class="nav-item" routerLink="/rewards/events">
            <span class="icon material-icons material-symbols-outlined">local_activity</span>
            <a class="nav-text text-white">{{ 'nav.events' | translate }}</a>
          </li>
          <li class="nav-item" routerLink="/rewards/marketplace">
            <span class="icon material-icons material-symbols-outlined">redeem</span>
            <a class="nav-text text-white">{{ 'menu.nav.giveaways' | translate }}</a>
          </li>
          <li class="nav-item" routerLink="/rewards/raffles">
            <span class="icon material-icons material-symbols-outlined">confirmation_number</span>
            <a class="nav-text text-white">{{ 'nav.raffles' | translate }}</a>
          </li>

          <li class="nav-item" routerLink="/games">
            <span class="icon material-icons material-symbols-outlined">sports_esports</span>
            <a class="nav-text text-white">{{ 'nav.games' | translate }}</a>
          </li>
          <li class="nav-item" routerLink="/leaderboard">
            <span class="icon material-icons material-symbols-outlined">equalizer</span>
            <a class="nav-text text-white">{{ 'menu.nav.leaderboard' | translate }}</a>
          </li>
          <li class="nav-item" routerLink="/gallery">
            <span class="icon material-icons material-symbols-outlined">animated_images</span>
            <a class="nav-text text-white">{{ 'nav.gallery' | translate }}</a>
          </li>
          <li class="nav-item" routerLink="/payment">
            <span class="icon material-icons material-symbols-outlined">credit_card</span>
            <a class="nav-text text-white">{{ 'nav.payment' | translate }}</a>
          </li>
          <li class="nav-item justify-content-between" (click)="isCollapsedNav = !isCollapsedNav">
            <div class="d-flex">
              <span class="icon material-icons material-dropdown-icon" aria-hidden="true">info</span>
              <div class="dropdown-link text-start">
                <span class="nav-text">{{ 'nav.help' | translate }}</span>
              </div>
            </div>
            <span
              [@expandAnimation]="isCollapsedNav ? 'close' : 'open'"
              class="icon material-icons material-dropdown-icon m-0"
              aria-hidden="true"
              >keyboard_arrow_down</span
            >
          </li>
          <ul class="sub-nav text-white" *ngIf="isCollapsedNav">
            <li class="nav-item nav-help-item">
              <a
                class="nav-link mx-2 p-0"
                [routerLink]="['/terms']"
                attr.aria-label="{{ 'nav.terms.screenreader' | translate : { fgbdefault: 'Move to terms page' } }}"
                >{{ 'nav.terms' | translate }}</a
              >
            </li>
            <li class="nav-item nav-help-item">
              <a
                class="nav-link mx-2 p-0"
                [routerLink]="['/faq']"
                attr.aria-label="{{ 'nav.faq.screenreader' | translate : { fgbdefault: 'Move to faq page' } }}"
                >{{ 'nav.faq' | translate }}</a
              >
            </li>
            <li class="nav-item nav-help-item">
              <a
                class="nav-link mx-2 p-0"
                [routerLink]="['/contact']"
                attr.aria-label="{{ 'nav.contact.us.screenreader' | translate : { fgbdefault: 'Move to contact us page' } }}"
                >{{ 'nav.contact.us' | translate }}</a
              >
            </li>
            <li class="nav-item nav-help-item">
              <a class="nav-link mx-2 p-0" href="{{ 'nav.more.info.link' | translate }}" target="_blank">
                {{ 'nav.more.info' | translate }}
              </a>
            </li>
          </ul>
        </ul>

        <a class="logout-btn text-white cursor-pointer mt-4" (click)="logout()">
          <i class="material-symbols-outlined material-icons me-2">logout</i>
          <span class="text-capitalize">{{ 'nav.log.out' | translate }}</span>
        </a>
      </div>
    </div>
  </div>
</div>
